import React, { useRef, useState } from "react";
import Address from "./Address";
import PaymentSuccess from "./Paymentsuccess";
import PaymentFailed from "./PaymentFailed";
import decryptCookieData from "./Functions/decryptCookieData";
import { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { getDistance } from "geolib";
import getCoordinatesFromAddress from "./utils/geocodeAddress";
import { useNavigate } from "react-router-dom";


const Checkout = ({ paybutton }) => {
    const [isEditingContact, setIsEditingContact] = useState(false);
    const [email, setEmail] = useState("");
    const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || null;
    const phonenumber = userData?.mobile || ""
    const [mobile, setMobile] = useState(phonenumber);
    const [showOptions, setShowOptions] = useState(false);
    const [selectedPayment, setSelectedPayment] = useState("Select pay");
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [percentage, setPercentage] = useState(0)
    const [advanceAmount, setAdvanceAmount] = useState(0);
    const [freeDeliveryRules, setFreeDeliveryRules] = useState([]);
    const [razorpay, setRazorpay] = useState({});
    const contactRef = useRef();
    const [selectedShippingAddress, setSelectedShippingAddress] = useState(null);
    const [selectedBillingAddress, setSelectedBillingAddress] = useState(null);
    const [validationError, setValidationError] = useState("");
    const [vendorAddress, setVendorAddress] = useState("")
    const [deliveryRules, setDeliveryRules] = useState([]);
    const [distanceInKm, setDistanceInKm] = useState(null);
    const [pincodes, setPincodes] = useState([])

    const navigate = useNavigate()

    const [checkoutInfo, setCheckoutInfo] = useState(null);
    const url = process.env.REACT_APP_API_URL


    const fetchPincodeData = async () => {
        try {
            const response = await fetch(`${url}/pincode/getall/${process.env.REACT_APP_PERFUME_ID}`)
            const res = await response.json();
            console.log(res.pincodesData)
            setPincodes(res.pincodesData);
        } catch (error) {
            console.log(error);
        }
    }

    const razorpayIdFetch = async () => {
        try {
            const response = await fetch(`${url}/pay-razorpay/${process.env.REACT_APP_PERFUME_ID}`)
            const res = await response.json();
            console.log(res);
            if (response.ok) {
                setRazorpay(res);
            }
        } catch (error) {
            console.log(error);
        }
    }
    useEffect(() => {
        const data = JSON.parse(localStorage.getItem("checkout_data"));
        setCheckoutInfo(data);
    }, []);



    const [data, setData] = useState({
        location_user: "",
        new_address: "",
        city: "",
        pincode: "",
        user_id: userData.user_id,
        user_name: userData.full_name,
        main_id: process.env.REACT_APP_PERFUME_ID,
        number: mobile,
        area: ""
    })
    const [formData, setFormData] = useState(null);


    useEffect(() => {
        if (checkoutInfo && selectedBillingAddress && selectedShippingAddress) {
            const totalAmount = checkoutInfo.totalAfterDiscount || 0;
            const deliveryCharge = calculateDeliveryCharge();
            // add this just before setFormData
            let upfrontAmount = totalAmount;
            let remainingPrice = 0;

            if (selectedPayment === "Pay on delivery" && percentage > 0) {
                upfrontAmount = Math.round((totalAmount * percentage) / 100);
                remainingPrice = totalAmount - upfrontAmount;
            }

            const paymentAdavnce = Number(upfrontAmount)
            setAdvanceAmount(paymentAdavnce);
            setFormData({
                user_id: userData?.user_id,
                order_id: "",
                payment_capture: "",
                currency: "",
                user_name: userData?.full_name,
                amountbeforediscount: checkoutInfo.totalBeforeDiscount,
                amountafterdiscount: Number(upfrontAmount) + Number(deliveryCharge || 0),
                deliveryCharge: deliveryCharge,
                remaining_amount: remainingPrice,
                cart_products: checkoutInfo.products,
                couponapplied: checkoutInfo.isCouponApplied,
                coupon_code: checkoutInfo.coupon,
                discountprice: checkoutInfo.discountAmount,
                billing_address: selectedBillingAddress,
                shipping_address: selectedShippingAddress,
                payment_mode: selectedPayment,
                totalAmountbeforePay: Number(checkoutInfo.totalAfterDiscount) + Number(deliveryCharge || 0),
                main_id: process.env.REACT_APP_PERFUME_ID
            });
        }
    }, [checkoutInfo, selectedBillingAddress, selectedShippingAddress, percentage, vendorAddress, deliveryRules, selectedPayment]);


    const toggleOptions = () => {
        setShowOptions(!showOptions);
    };

    const selectPayment = (option) => {
        setSelectedPayment(option);
        setShowOptions(false); // Close options after selection
    };



    const fetchData = async () => {
        try {
            const response = await fetch(`${url}/registeruser/single/${userData.user_id}`)
            const res = await response.json();
            setMobile(res.mobile)
        } catch (error) {
            console.error(error)
        }
    }


    const submitMobile = async () => {
        setIsEditingContact(false)
        try {
            const response = await fetch(`${url}/registeruser/api/user/${userData.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ mobile })
            })
            const res = await response.json();
            if (res.success) {
                await fetchData();
            }
        } catch (error) {
            console.error(error)
        }
    }
    // const placeOrder = async () => {
    //     if (!formData) return;

    //     try {
    //         const response = await fetch(`${url}/payment`, {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify(formData),
    //         });

    //         const result = await response.json();

    //         if (result.success) {
    //             openRazorpay(result.razorpay_order, result.order_id);
    //         } else {
    //             toast.error("Failed to create Razorpay order");
    //         }
    //     } catch (err) {
    //         console.error("Error placing order:", err);
    //         toast.error("Error during checkout");
    //     }
    // };

    const placeOrder = async () => {
        if (!selectedBillingAddress) {
            setValidationError("Please select a billing address.");
            toast.error("Please select a billing address.")
            return;
        }

        if (!selectedShippingAddress) {
            setValidationError("Please select a shipping address.");
            toast.error("Please select a shipping address.")
            return;
        }

        if (!mobile || mobile?.length !== 10) {
            setIsEditingContact(true);
            setValidationError("Please enter a valid 10-digit mobile number.");
            contactRef.current?.scrollIntoView({ behavior: "smooth" });
            toast.error("Please enter a valid 10-digit mobile number.");
            return;
        }
        if (selectedPayment === "Select pay") {
            setValidationError("Please select a payment method.");
            toast.error("Please select a payment method.");
            return;
        }


        formData.key_id = razorpay?.key_id;
        formData.key_secret = razorpay?.key_secret;


        const activePincodeList = pincodes
            .filter(p => p.status === "Active")
            .map(p => p.pincode?.toString());
        if (
            activePincodeList.length > 0 &&
            !activePincodeList.includes(selectedShippingAddress?.pincode?.toString())
        ) {
            setValidationError("Delivery is not available to this pincode.");
            toast.error("Sorry, we do not deliver to this pincode.");
            return;
        }

        setValidationError("");
        if (selectedPayment === "Pay on delivery" && percentage === 0) {
            try {
                const response = await fetch(`${url}/payment/paydelivery`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(formData),
                });

                const result = await response.json();
                if (result.success) {
                    navigate(`/payment-success/${result.order_id}`);
                } else {
                    toast.error("Failed to create Razorpay order");
                }
            } catch (err) {
                console.error("Error placing order:", err);
                toast.error("Error during checkout");
            }
        } else {
            try {
                const response = await fetch(`${url}/payment`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(formData),
                });

                const result = await response.json();
                if (result.success) {
                    openRazorpay(result.razorpay_order, result.order_id);
                } else {
                    toast.error("Failed to create Razorpay order");
                }
            } catch (err) {
                console.error("Error placing order:", err);
                toast.error("Error during checkout");
            }
        }
    };
    console.log(selectedPayment, percentage)
    const openRazorpay = (razorpayOrder, order_id) => {
        const options = {
            key: `${razorpay.key_id}`,
            amount: razorpayOrder.amount,
            currency: razorpayOrder.currency,
            name: `${razorpay.company_name}`,
            description: "Order Payment",
            order_id: razorpayOrder.id,
            handler: async function (response) {
                const verifyRes = await fetch(`${url}/payment/verify`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        razorpay_order_id: response.razorpay_order_id,
                        razorpay_payment_id: response.razorpay_payment_id,
                        razorpay_signature: response.razorpay_signature,
                        key_id: razorpay.key_secret,
                    }),
                });

                const verifyData = await verifyRes.json();
                if (verifyData.success) {
                    window.location.href = `/payment-success/${order_id}`; // ✅ Redirect on success
                } else {
                    window.location.href = `/payment-failed/${order_id}`; // ❌ Redirect on failure
                }
            },
            prefill: {
                name: userData?.full_name,
                email: userData?.email,
                contact: mobile,
            },
            theme: { color: "#3399cc" },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
    };



    const calculateDeliveryCharge = () => {
        if (
            !selectedShippingAddress ||
            !vendorAddress ||
            !deliveryRules.length ||
            !vendorAddress?.latitude ||
            !vendorAddress?.longitude ||
            !selectedShippingAddress.latitude ||
            !selectedShippingAddress.longitude
        ) {
            return 0;
        }

        const distanceMeters = getDistance(
            {
                latitude: parseFloat(vendorAddress?.latitude),
                longitude: parseFloat(vendorAddress?.longitude),
            },
            {
                latitude: parseFloat(selectedShippingAddress.latitude),
                longitude: parseFloat(selectedShippingAddress.longitude),
            }
        );

        const distanceKm = distanceMeters / 1000;
        let roundedDistance;

        if (distanceKm > 0.1 && distanceKm < 1) {
            roundedDistance = 1;
        } else {
            roundedDistance = Math.round(distanceKm);
        }
        setDistanceInKm(roundedDistance);

        const cartTotal = checkoutInfo?.totalAfterDiscount || 0;


        const freeRule = freeDeliveryRules.find(rule =>
            distanceKm >= rule.min_kilometer &&
            distanceKm <= rule.max_kilometer &&
            cartTotal >= rule.freedelivery_price
        );
        if (freeRule) {
            return 0;
        }

        const matchedRule = deliveryRules.find(
            (rule) =>
                distanceKm >= rule.min_kilometer &&
                distanceKm <= rule.max_kilometer &&
                rule.status === "Active"
        );

        return matchedRule?.delivery_price || 0;
    };



    const fetchDeliveryPayData = async () => {
        try {
            const response = await fetch(`${url}/deliverypaybefore/single/${process.env.REACT_APP_PERFUME_ID}`);
            const res = await response.json();
            if (res?.help?.delivery_percentage) {
                setPercentage(Number(res.help.delivery_percentage));
            } else {
                setPercentage(0);
            }
        } catch (error) {
            console.error("Error fetching delivery data:", error);
            setPercentage(0);
        }
    };

    const fetchDelivery = async () => {
        try {
            const response = await fetch(`${url}/delivery-price/${process.env.REACT_APP_PERFUME_ID}`);
            const res = await response.json();
            setDeliveryRules(res.data || []);
        } catch (error) {
            console.error("Delivery price fetch error:", error);
            setDeliveryRules([]);
        }
    };


    const fetchDataAddressAdmin = async () => {
        try {
            const response = await fetch(`${url}/register/officesingle/${process.env.REACT_APP_PERFUME_ID}`)
            const res = await response.json();
            setVendorAddress(res.google_address)
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        const fetchCoordinatesForAddresses = async () => {
            // Only geocode if distance is needed and not already present
            if (
                (!vendorAddress?.latitude || !vendorAddress?.longitude) &&
                typeof vendorAddress === "string"
            ) {
                const coords = await getCoordinatesFromAddress(vendorAddress);
                if (coords) {
                    setVendorAddress(prev => ({
                        ...coords, // add latitude, longitude
                        raw: vendorAddress // optionally keep raw string
                    }));
                }
            }

            if (
                selectedShippingAddress &&
                (!selectedShippingAddress.latitude || !selectedShippingAddress.longitude)
            ) {
                const coords = await getCoordinatesFromAddress(selectedShippingAddress.area);
                if (coords) {
                    setSelectedShippingAddress(prev => ({
                        ...prev,
                        latitude: coords.latitude,
                        longitude: coords.longitude,
                    }));
                }
            }
        };

        fetchCoordinatesForAddresses();
    }, [vendorAddress, selectedShippingAddress]);


    const deliveryCheckfree = async () => {
        try {
            const response = await fetch(`${url}/freedelivery/${process.env.REACT_APP_PERFUME_ID}`)
            const res = await response.json();
            if (Array.isArray(res.data)) {
                setFreeDeliveryRules(res.data);
            }
        } catch (error) {
            console.error(error)
            setFreeDeliveryRules([]);
        }
    }


    useEffect(() => {
        razorpayIdFetch();
        fetchData();
        fetchDeliveryPayData();
        fetchDelivery();
        fetchDataAddressAdmin();
        deliveryCheckfree();
        fetchPincodeData();
    }, [])


    // const getDefaultCartButton = () => {
    //     const isGetQuoteDefault = paybutton.find(b => b.button_id === 'paymanual' && b.default);
    //     if (isGetQuoteDefault) return 'paymanual';

    //     const isAddToCartDefault = paybutton.find(b => b.button_id === 'paynow' && b.default);
    //     if (isAddToCartDefault) return 'paynow';

    //     const isBuyNowDefault = paybutton.find(b => b.button_id === 'payondelivery' && b.default);
    //     if (isBuyNowDefault) return 'payondelivery';

    //     return null; // fallback
    // };
    const getDefaultCartButton = () => {
        const hasPayNow = paybutton.some(b => b.button_id === 'paynow');
        const hasPayOnDelivery = paybutton.some(b => b.button_id === 'payondelivery');

        if (hasPayNow && hasPayOnDelivery) return 'both';
        if (hasPayNow) return 'paynow';
        if (hasPayOnDelivery) return 'payondelivery';
        return null;
    };

    const defaultButtonPay = getDefaultCartButton();


    return (
        <>
            <ToastContainer position="top-center" autoClose={3000} />
            <div className="checkout-perfume">
                <div className="cart-columns-perfume">
                    <div className="address-container cart-column1-perfume">
                        <Address data={data} setData={setData} selectedBillingAddress={selectedBillingAddress} setSelectedShippingAddress={setSelectedShippingAddress} setSelectedBillingAddress={setSelectedBillingAddress} selectedShippingAddress={selectedShippingAddress} />
                        <div ref={contactRef} className="contact-info-section">
                            <h3>Contact Information</h3>

                            {isEditingContact ? (
                                <div className="contact-fields">
                                    <div className="field-group">
                                        <label>Email</label>
                                        <input
                                            type="email"
                                            value={userData.email}
                                            disabled
                                        />
                                    </div>

                                    <div className="field-group">
                                        <label>Mobile Number</label>
                                        <input
                                            type="text"
                                            value={mobile}
                                            onChange={(e) => {
                                                let input = e.target.value.replace(/\s|-/g, '');
                                                if (input.startsWith('+91')) input = input.slice(3);
                                                else if (input.startsWith('91') && input.length > 10) input = input.slice(2);
                                                else if (input.startsWith('0')) input = input.slice(1);

                                                input = input.replace(/\D/g, '');
                                                if (input.length > 10) input = input.slice(0, 10);

                                                setMobile(input);
                                            }}
                                            placeholder="Enter 10-digit mobile number"
                                        />
                                        {mobile?.length !== 10 && (
                                            <p className="mobile-error">Please enter a valid 10-digit mobile number.</p>
                                        )}
                                    </div>

                                    <button
                                        className="save-contact-btn"
                                        onClick={submitMobile}
                                        disabled={mobile?.length !== 10}
                                    >
                                        Save
                                    </button>
                                </div>
                            ) : (
                                <div className="contact-display">
                                    <p><strong>Email:</strong> {userData.email}</p>
                                    <p><strong>Mobile:</strong> {mobile || "Not provided"}</p>
                                    <button
                                        className="save-contact-btn"
                                        onClick={() => setIsEditingContact(true)}
                                    >
                                        Change
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="cart-column2-perfume">
                        <div className="cart-column2-header-perfume">
                            <h3>Order Summary</h3>
                        </div>
                        <div className="cart-column2-total-perfume">
                            <div className="cart-total-labels">
                                <p><strong>Total Price</strong></p>
                                <p>Original Price</p>
                                <p>Delivery Charge</p>
                                {(percentage > 0 && selectedPayment === "Pay on delivery") && (
                                    <p>Advance Payable</p>
                                )}
                            </div>
                            <div className="cart-total-value">
                                <p><strong>₹{checkoutInfo?.totalAfterDiscount}</strong></p>
                                <p>₹{checkoutInfo?.totalBeforeDiscount}</p>
                                <p>₹{formData?.deliveryCharge || 0}</p>
                                {(percentage > 0 && selectedPayment === "Pay on delivery") && (
                                    <p>₹{advanceAmount}</p>
                                )}
                            </div>
                        </div>

                        <div className="payment-container">
                            <div className="payment-text" onClick={toggleOptions}>
                                <div>Pay using</div>
                                <div>{selectedPayment} <i class="fa-solid fa-angle-down"></i></div>
                            </div>

                            {
                                showOptions && (
                                    <div className="payment-options">
                                        {paybutton.some(b => b.button_id === 'payondelivery' && b.default) && (
                                            <div onClick={() => selectPayment("Pay on delivery")}>Pay on delivery</div>
                                        )}
                                        {paybutton.some(b => b.button_id === 'paynow' && b.default) && (
                                            <div onClick={() => selectPayment("Pay now")}>Pay now</div>
                                        )}
                                    </div>
                                )
                            }




                            <button className="payment-button" onClick={placeOrder}>Place order</button>
                        </div>
                        {(percentage > 0 && selectedPayment === "Pay on delivery") && (
                            <div className="delivery-pay-note" style={{ marginTop: "10px", color: "#d9534f", fontWeight: "bold", textAlign: "center", fontSize: "15px" }}>
                                You need to pay {percentage}% now online.
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {showSuccessModal && <PaymentFailed onClose={() => setShowSuccessModal(false)} />}
        </>
    );
};

export default Checkout;
